import React from 'react';
import { EquallyDistributedTieredProgressBarProps } from '../../types';
import { Tiered } from '../Tiered';
import { useEquallyDistributed } from './hooks';

export const EquallyDistributed: React.FC<EquallyDistributedTieredProgressBarProps> = (props) => {
  const formattedProps = useEquallyDistributed(props);
  return <Tiered {...formattedProps} />;
};
